/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-nested-ternary */
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import { useReceberMesaTelefone } from "services/api/AppWeb_Mesa_Telefone/MesaTelefone";
import { format, utcToZonedTime } from "date-fns-tz";
import regexPhone from "utils/regexPhone";
import { parseISO } from "date-fns";
import * as Styles from "./styles";
import NavCommon from "../../components/@navHeader";
import * as IconSVG from "../../assets/iconsSVG";

const MesaTelefone = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { data: mesaTelefoneData } = useReceberMesaTelefone();

  const handleRefresh = () => {
    window.location.reload();
  };

  const timeZone = "UTC";

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);
  const history = useHistory();

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "", name: "Mesa de telefone" }]}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => history.push("/")}
      />
      <Styles.Content>
        <Styles.Title>Mesa de telefone</Styles.Title>
        <Styles.Container>
          <Styles.HeaderTable>
            <Styles.TitleSub>Fila de atendimento</Styles.TitleSub>
          </Styles.HeaderTable>
          <Styles.ContainerSub>
            <Styles.ContainerSubHeader>
              <Styles.TitleTwoSub>Equipe de atendimento</Styles.TitleTwoSub>
              {mesaTelefoneData ? (
                <Styles.ContainerBtn
                  style={{
                    backgroundImage: "#EAEFFF",
                  }}
                  onClick={handleRefresh}
                >
                  <p
                    style={{
                      color: "#2D5BFF",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <IconSVG.ReloadIcon /> Atualizar fila
                  </p>
                </Styles.ContainerBtn>
              ) : (
                ""
              )}
            </Styles.ContainerSubHeader>
            {isLoading ? (
              <Skeleton
                variant="rounded"
                width="100%"
                height={350}
                sx={{ mt: 2 }}
              />
            ) : mesaTelefoneData?.corretoresAtendimento?.length > 0 ? (
              <>
                {/* primeiro container */}
                <Styles.ContainerHeaderList>
                  <Styles.TitleHeaderList style={{ minWidth: 350 }}>
                    Vez no atendimento
                  </Styles.TitleHeaderList>
                  <Styles.TitleHeaderList style={{ width: 2000 }}>
                    Ramal
                  </Styles.TitleHeaderList>
                  <Styles.TitleHeaderList>Nº de atend.</Styles.TitleHeaderList>
                </Styles.ContainerHeaderList>
                <Styles.ContainerHeaderListInfo>
                  <Styles.TitleHeaderListInfo style={{ minWidth: 350 }}>
                    {mesaTelefoneData.corretoresAtendimento[0].vezNoAtendimento}
                     {mesaTelefoneData.corretoresAtendimento[0].nomeCorretor}
                  </Styles.TitleHeaderListInfo>
                  <Styles.TitleHeaderListInfo style={{ width: 2000 }}>
                    {mesaTelefoneData.corretoresAtendimento[0].ramal}
                  </Styles.TitleHeaderListInfo>
                  <Styles.TitleHeaderListInfo style={{ color: "#2D5BFF" }}>
                    (
                    {mesaTelefoneData.corretoresAtendimento[0]
                      .quantidadeAtendimentos ?? 0}
                    )
                  </Styles.TitleHeaderListInfo>
                </Styles.ContainerHeaderListInfo>

                {/* segundo container */}
                <Styles.ContainerHeaderList>
                  <Styles.TitleHeaderList style={{ minWidth: 350 }}>
                    Próximo na fila
                  </Styles.TitleHeaderList>
                  <Styles.TitleHeaderList style={{ width: 2000 }}>
                    Ramal
                  </Styles.TitleHeaderList>
                  <Styles.TitleHeaderList>Nº de atend.</Styles.TitleHeaderList>
                </Styles.ContainerHeaderList>
                {mesaTelefoneData.corretoresAtendimento
                  .slice(1)
                  .map((item: any) => (
                    <Styles.ContainerHeaderListInfo2
                      key={item.idUsuarioCorretorAtendimento}
                    >
                      <Styles.TitleHeaderListInfo style={{ minWidth: 350 }}>
                        {item.vezNoAtendimento} {item.nomeCorretor}
                      </Styles.TitleHeaderListInfo>
                      <Styles.TitleHeaderListInfo style={{ width: 2000 }}>
                        {item.ramal}
                      </Styles.TitleHeaderListInfo>
                      <Styles.TitleHeaderListInfo style={{ color: "#2D5BFF" }}>
                        ({item.quantidadeAtendimentos ?? 0})
                      </Styles.TitleHeaderListInfo>
                    </Styles.ContainerHeaderListInfo2>
                  ))}
              </>
            ) : (
              <Styles.BottomTable>
                <Styles.TextP>
                  Ainda não foi cadastrada uma equipe para esse período
                </Styles.TextP>
              </Styles.BottomTable>
            )}
          </Styles.ContainerSub>
          <Styles.HeaderTable>
            <Styles.TitleSub>Atendimentos Realizados</Styles.TitleSub>
          </Styles.HeaderTable>
          {isLoading ? (
            <Skeleton
              variant="rounded"
              width="100%"
              height={350}
              sx={{ mt: 2 }}
            />
          ) : mesaTelefoneData?.atendimentosRealizados.length > 0 ? (
            <>
              {/* container telefone */}
              <Styles.ContainerHeaderList>
                <Styles.TitleHeaderList style={{ minWidth: 350 }}>
                  Cliente
                </Styles.TitleHeaderList>
                <Styles.TitleHeaderList style={{ minWidth: 350 }}>
                  Telefone
                </Styles.TitleHeaderList>
                <Styles.TitleHeaderList style={{ width: 2000 }}>
                  E-mail
                </Styles.TitleHeaderList>
                <Styles.TitleHeaderList>
                  Horário do atendimento
                </Styles.TitleHeaderList>
              </Styles.ContainerHeaderList>
              {mesaTelefoneData.atendimentosRealizados.map((item: any) => (
                <Styles.ContainerHeaderListInfo2 key={item.vezNoAtendimento}>
                  <a
                    href={`/lead-detail/${item.idLeadCorretor365}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: "none",
                      color: "#000000",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <Styles.TitleHeaderListInfo style={{ minWidth: 350 }}>
                      {item.nomeLead}
                    </Styles.TitleHeaderListInfo>
                  </a>
                  <Styles.TitleHeaderListInfo style={{ minWidth: 350 }}>
                    {item.telefone ? (
                      <a
                        href={`https://wa.me/${item.telefone}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "#000000",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <IconSVG.WhatsappIcon />
                        {regexPhone(item.telefone)}
                      </a>
                    ) : (
                      "Sem telefone"
                    )}
                  </Styles.TitleHeaderListInfo>
                  <Styles.TitleHeaderListInfo style={{ width: 2000 }}>
                    {item.email ? (
                      <a
                        href={`mailto:${item.email}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "#000000",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <IconSVG.EmailOutlookIcon />
                        {item.email}
                      </a>
                    ) : (
                      "Sem e-mail"
                    )}
                  </Styles.TitleHeaderListInfo>
                  <Styles.TitleHeaderListInfo>
                    {format(
                      utcToZonedTime(parseISO(item.dataCriacao), timeZone),
                      "dd/MM/yyyy HH:mm",
                      { timeZone }
                    )}
                  </Styles.TitleHeaderListInfo>
                </Styles.ContainerHeaderListInfo2>
              ))}
            </>
          ) : (
            <Styles.BottomTable>
              <Styles.TextP>Nenhum atendimento realizado</Styles.TextP>
            </Styles.BottomTable>
          )}
        </Styles.Container>
      </Styles.Content>
    </>
  );
};

export default MesaTelefone;
